const url = {
  insertArguments: (url: string, args: { [key: string]: string }): string => {
    for (const key in args) {
      const value = args[key];
      url = url.replace('{' + key + '}', value);
    }

    return url;
  },
} as const;

/**
 * Encodes a URL to handle special characters (spaces, etc.) for fetch requests.
 * Uses URL constructor for proper parsing, falls back to encodeURI for invalid URLs.
 */
export const encodeUrlForFetch = (urlString: string): string => {
  if (!urlString) {
    return '';
  }
  try {
    const urlObj = new URL(urlString);
    return urlObj.href;
  } catch {
    return encodeURI(urlString);
  }
};

export { url };
